import tracker from 'libs/tracking';
import { createContext, useEffect, useState } from 'react';
import AnalyticsService, { helixConfig } from 'libs/tracking/adapters/helix/helixService';
import { KiteProgressIndicator } from '@kite/react-kite';

import {
  getLoggedInAccountGuid,
  getLoggedInAccountNumber,
  getLoggedInFootprint,
  getLoggedInVisitIdStorage,
  setLoggedInVisitIdStorage,
} from 'utils/accessTokenLocalStorage';
import { TrackingHook, useTracking } from 'react-tracking';
import { getIsLoggedIn } from 'providers/AuthProvider';

export const AnalyticsContext = createContext({});

const AnalyticsProvider: React.FC = ({ children }) => {
  const [isAnalyticsReady, setIsAnalyticsReady] = useState<null | { success: boolean; visitId?: string }>(null);
  const analytics = new AnalyticsService(helixConfig);
  const { trackEvent }: TrackingHook = useTracking({ page: 'login' });
  const getReferrerData = (): { referrerAppName: string; referrerAppVisitId: string; appRefLink: string } => {
    const urlParams = new URLSearchParams(window?.location?.search);
    return {
      referrerAppName: urlParams.get('referrerAppName') || '',
      referrerAppVisitId: urlParams.get('referrerAppVisitId') || '',
      appRefLink: window?.document?.referrer || '',
    };
  };

  const initializeAnalytics = async (): Promise<void> => {
    const referrerData = getReferrerData();
    const result = await analytics.init(referrerData);

    if (getIsLoggedIn() && result.visitId !== getLoggedInVisitIdStorage()) {
      trackEvent({
        event: 'updateUserConfig',
        accountNumber: getLoggedInAccountNumber(),
        footprint: getLoggedInFootprint(),
        accountGuid: getLoggedInAccountGuid(),
      });
      setLoggedInVisitIdStorage(result.visitId || '');
    }

    setIsAnalyticsReady(result);
  };

  useEffect(() => {
    if (!isAnalyticsReady) {
      initializeAnalytics();
    }
  }, [isAnalyticsReady]);

  if (!isAnalyticsReady) {
    return <KiteProgressIndicator id={'analytics'} />;
  }

  return <AnalyticsContext.Provider value={{}}>{children}</AnalyticsContext.Provider>;
};

export default tracker(AnalyticsProvider);
